"use strict";
/**
 * Extension to use using statement with IDisposable
 *
 * Excample:
 * using(new AnyClass(), (instance) => {
 *  instance.doAnything();
 * });
 */
function using(resource, func) {
    try {
        func(resource);
    }
    catch (error) {
        resource.dispose();
        throw error;
    }
}
exports.using = using;
